import { ReactPlayerVideo } from '@/components/VideoPlayer/ReactPlayerVideo';
import { CameraHlsVideo } from '@/components/VideoPlayer/CameraHlsVideo';
import { WebRTCVideo } from '@/components/VideoPlayer/WebRTCVideo';
import { VideoLoadingState } from '@/components/VideoPlayer/VideoLoadingState';
import { useVideoPlayerContext } from '@/components/VideoPlayer/VideoPlayerProvider';
import { SourceType } from '@/types/source';
import type { FullSource } from '@/types/source';

interface PipVideoContentProps {
    source: FullSource;
}

export function PipVideoContent({ source }: PipVideoContentProps) {
    const { streaming, showErrorState } = useVideoPlayerContext();

    if (showErrorState) {
        return (
            <div className="flex items-center justify-center w-full h-full bg-black-100">
                <div className="text-center text-grey-300 px-4">
                    <p className="text-sm font-medium">Unable to load stream</p>
                </div>
            </div>
        );
    }

    if (streaming.shouldUseWebRTC) {
        return <WebRTCVideo />;
    }

    if (!streaming.videoSrc) {
        return <VideoLoadingState />;
    }

    if (source.type === SourceType.CAMERA) {
        return <CameraHlsVideo />;
    }

    return <ReactPlayerVideo />;
}
